import { render, staticRenderFns } from "./EditableCellChatroomNum.vue?vue&type=template&id=72f1274c&scoped=true&"
import script from "./EditableCellChatroomNum.vue?vue&type=script&lang=js&"
export * from "./EditableCellChatroomNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f1274c",
  null
  
)

export default component.exports